import { useSalesReportFilters } from '../useSalesReportFilters'
import { useFetchSalesByCustomerReport } from './useFetchSalesByCustomerReport'

export const useSalesByCustomerReport = () => {
  const [{ period }] = useSalesReportFilters()
  const { salesByCustomerReport, isLoading } = useFetchSalesByCustomerReport({ period })

  return { salesByCustomerReport, isLoading }
}
